import { __assign, __rest } from 'tslib';
import React__default from 'react';
import { useTheme, Box, LinearProgress, Backdrop } from '@mui/material';
import clsx from 'clsx';
import { useSpring, animated } from 'react-spring';
import { isChromiumBased } from '../lib/browser/index.js';
import StyledKModal, { classes } from './index.styled.js';

// Backdrop used to show modal scrollbar in Chromium browser, on other browsers
// (including Firefox) no backdrop is displayed
var KModalScrollbarBackdrop = function (_a) {
    var sx = _a.sx, rest = __rest(_a, ["sx"]);
    return (React__default.createElement(Backdrop, __assign({ sx: __assign({ zIndex: "-1" }, (sx && sx)) }, rest, { invisible: true })));
};
var KModal = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? "KModal" : _b, header = _a.header, open = _a.open, onClose = _a.onClose, disableEnforceFocus = _a.disableEnforceFocus, _c = _a.loading, loading = _c === void 0 ? false : _c, className = _a.className, id = _a.id, children = _a.children, ariaDescription = _a.ariaDescription, ariaLabel = _a.ariaLabel, _d = _a.scrollbarVisible, scrollbarVisible = _d === void 0 ? false : _d, size = _a.size, sx = _a.sx;
    var theme = useTheme();
    var animatedProps = useSpring({
        opacity: open ? 1 : 0,
        scale: open ? 1 : 0.95,
        config: { duration: theme.transitions.duration.enteringScreen }
    });
    var backdropStyle = {
        // Override backdropColor default behavior
        backdropFilter: "grayscale(1)",
        backgroundColor: "rgba(0,0,0,0.5) !important"
    };
    return (React__default.createElement(StyledKModal, { disableEnforceFocus: disableEnforceFocus || false, open: open, id: id, "data-testid": testId, className: clsx("KModal", className, open && "KModal-open"), onClose: onClose, "aria-labelledby": ariaLabel, "aria-describedby": ariaDescription, BackdropComponent: scrollbarVisible ? KModalScrollbarBackdrop : undefined, BackdropProps: {
            className: clsx("KModalBackdrop"),
            sx: __assign({}, (!scrollbarVisible && backdropStyle))
        }, hideBackdrop: scrollbarVisible && !isChromiumBased(), "aria-busy": loading, size: size, sx: __assign(__assign({}, (scrollbarVisible && backdropStyle)), (sx && sx)) },
        React__default.createElement(Box, { component: "aside", className: classes.scrollBox },
            React__default.createElement(animated.div, { style: animatedProps, className: classes.content, "aria-busy": loading, role: "dialog" },
                !!header && header,
                loading && React__default.createElement(LinearProgress, null),
                React__default.createElement("div", { className: classes.body }, children)))));
};

export { KModal as default };
//# sourceMappingURL=index.js.map
